import { Theme } from "@material-ui/core"
import IconButton from "@material-ui/core/IconButton"
import makeStyles from "@material-ui/core/styles/makeStyles"
import AddIcon from "@material-ui/icons/Add"
import React, { useContext } from "react"
import { AppContext } from "Views/Home/context"
import { CalendarContext } from "../context"
import CandidateItem from "./CandidateItem"
import { Board, BoardAction, BoardModifyDialog } from "Types/board"
import { useMouseGesture } from "Hooks/basic"
import { useUpdateWeChatBoardTime, useDeleteBoard, useUpdateBoardTime,  useUpdateSpeciesBoardTime, useUpdateEatBoardTime, useUpdateHealthBoardTime } from "Hooks/board"
import { useFetchDraft } from "Hooks/draft"
import { InitialModal } from "Methods/modal"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: 200,
        right: 0,
        top: 0,
        zIndex: 100,
        cursor: "pointer",
        padding: theme.spacing(2),
        boxSizing: "border-box",
        borderBottom: "1px solid #ddd",
        borderRight: "1px solid #ddd",
        borderTop: "2px solid #ddd",
        marginTop: 20,
        textAlign: "right",
        maxHeight: 796,
        overflowY: "scroll",
    },
    addIcon: {
    },
    draftItem: {
        position: "relative",
        borderRadius: 6,
        padding: "0 20px 0 10px",
        cursor: "pointer",
        transition: "all .3s ease",
        wordBreak: "break-word",
        userSelect: "none",
        width: "80%",
        height: 20,
        color: "white",
        marginTop: 10,
        "&:hover": {
            width: "90%",
            height: 40,
            transition: "all .3s ease",
        },
    },
    icon: {
        fontWeight: "bold",
        position: "absolute",
        right: 1,
        top: 0,
        opacity: 0,
    },
    iconShow: {
        opacity: 1,
    },
}))
interface ComponentProps {
    text?: string
}
const CandidateList = (props: ComponentProps) => {
    const classes = useStyles()
    const {
        handleChangeBoardModifyDialog, boardModifyDialog,
        movableBoard, privilegeMap, channelName, isSpecies, isHealth,
    } = useContext(CalendarContext)
    const { handleChangeModal, user } = useContext(AppContext)
    const data = useFetchDraft(channelName)
    const { updateTime } = useUpdateWeChatBoardTime()
    const { update } = useUpdateBoardTime()
    const { updateSpeciesTime } = useUpdateSpeciesBoardTime()
    const { updateEatTime } = useUpdateEatBoardTime()
    const { updateHealthTime } = useUpdateHealthBoardTime()
    const { del } = useDeleteBoard(channelName)
    const isMoving = movableBoard !== null && movableBoard.id && movableBoard.ad_time
    const { show, handleMouseEnter, handleMouseLeave } = useMouseGesture()
    const { role } = user
    const { role_name } = role || {}
    const isTrueEditor = role_name === "true_editor"
    const isOpEditor = role_name === "op_editor"
    const isSideEditor  = role_name === "side_editor"
    const isEat = channelName === '吃货'
    const privilege = privilegeMap.draft
    const handleDelBoard = async (boardId: number) => {
        await del({
            variables: {
                id: boardId,
            },
        })
    }
    const handleAddDraft = () => {
        if (
            (!privilege.insert && !isSpecies)
            || (isSpecies && !isTrueEditor && !isSideEditor)
        ) {
            return
        }
        let type: BoardAction

        switch (channelName) {
            case '微信':
                type = 'draft_create';
                break;
            case '微博':
                type = 'weibo_draft_create';
                break;
            case '吃货':
                type = 'eat_draft_create';
                break;
            case '果壳自然':
                type = 'species_draft_create';
                break;
            default:
                type = 'health_draft_create';
        }
        // const type: BoardAction = isWeChat ? "draft_create" : "weibo_draft_create"
        handleChangeBoardModifyDialog({
            ...(boardModifyDialog as BoardModifyDialog),
            show: true,
            type,
        })
    }
    const handleEndMove = async () => {
        if ((!privilege.insert && !isSpecies && !isHealth) || ((isSpecies || isHealth) && !isTrueEditor && !isSideEditor) || (isHealth && !isSideEditor && !isTrueEditor)) {
            if (movableBoard) {
                handleChangeModal({
                    show: true,
                    type: "warning",
                    customButtons: [],
                    title: "暂无权限添加草稿",
                    timeout: 3000,
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
            }

            return
        }
        if (movableBoard && movableBoard.id) {
            if (!movableBoard.ad_time) {
                handleChangeModal({
                    show: true,
                    type: "warning",
                    customButtons: [],
                    title: "暂无权限删除预约",
                    timeout: 3000,
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
                return
            }
            try {
                switch (channelName) {
                    case '微信':
                        if (movableBoard.seq_id === 100) {
                        return
                        }
                        const data = {
                            ad_time: new Date(),
                            seq_id: 100,
                            description: movableBoard.description,
                            author_id: movableBoard.author_id,
                            article_type_id: movableBoard.article_type_id,
                            is_draft: true,
                        }
                        await updateTime(
                            movableBoard.id, data,
                        );
                        break;
                    case '微博':
                        await update({
                           variables: {
                               is_draft: true,
                               id: movableBoard.id,
                               ad_time: movableBoard.ad_time,
                               ad_place_id: movableBoard.ad_place_id,
                           },
                        });
                        break;
                    case '吃货':
                        await updateEatTime({
                            variables: {
                                is_draft: true,
                                id: movableBoard.id,
                                ad_time: new Date(),
                                ad_place_id: Number(process.env.EAT_PLACE || 236),
                                seq_id: 1,
                            },
                        })
                        break;
                    case '果壳自然':
                        await updateSpeciesTime({
                            variables: {
                                is_draft: true,
                                id: movableBoard.id,
                                ad_time: new Date(),
                                ad_place_id: Number(process.env.SPECIES_PLACE || 236),
                                seq_id: 1,
                            },
                         });
                        break;
                    default:
                        await updateHealthTime({
                            variables: {
                                is_draft: true,
                                id: movableBoard.id,
                                ad_time: new Date(),
                                ad_place_id: Number(process.env.HEALTH_PLACE || 285),
                                seq_id: 1,
                            },
                         });
                         break;

                }
            } catch (err) {
                const { response: { data = {} } = {}, message } = (err as any)
                handleChangeModal({
                    show: true,
                    type: "warning",
                    customButtons: [],
                    title: data.message || message,
                    timeout: 3000,
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
            }
        }
    }
    return (
        <div
            className={classes.root}
            onPointerUp={handleEndMove}
            onPointerEnter={handleMouseEnter}
            onPointerLeave={handleMouseLeave}
        >
            { (channelName !== '果壳病人' || (channelName === '果壳病人' && (isTrueEditor || isSideEditor))) &&
                <IconButton onClick={handleAddDraft} className={classes.addIcon}>
                <AddIcon />
            </IconButton>}
            { show && isMoving && <CandidateItem board={movableBoard as Board} onDelete={() => {}}/>}
            {
                data && data.map((d: Board) => (
                    <CandidateItem key={d.id} board={d} onDelete={handleDelBoard}/>
                ))
            }
        </div>
    )
}

export default CandidateList
